import React from 'react';
import { useStoreConfigContext } from '/src/providers';
import { ButtonTop } from '/src/components';
import * as styles from './styles.scss';

const Menu  = ({
    isAuth,
    logout,
    account,
    handleShowAccount,
    disabled,
}) => {
    const { translate } = useStoreConfigContext();

    return (
        <div className={styles.menu}>
            <ButtonTop
                className={styles.account}
                onClick={handleShowAccount}
                aria-label="Login"
                disabled={disabled || isAuth}
            />
            {
                isAuth &&
                <div className={styles.container}>
                    <div className={styles.auth}>
                        <button
                            onClick={account}
                            disabled={disabled}
                        >
                            {translate('My account')}
                        </button>
                        <button
                            onClick={logout}
                            disabled={disabled}
                        >
                            {translate('Logout')}
                        </button>
                    </div>
                </div>
            }
        </div>
    )
};

export default Menu;
